module.exports = __webpack_public_path__ + "img/img02.c64a78dc.jpg";